const checklistSections = [
  {
    title: "Account flow",
    items: [
      "Create a new user account",
      "Receive verification email",
      "Verify email and refresh",
      "Log out and log back in",
      "Edit profile photo, banner, background, username, and bio"
    ]
  },
  {
    title: "Creator flow",
    items: [
      "Become a creator",
      "Complete creator onboarding",
      "Create a limited moment",
      "Create an open moment",
      "Delete a moment from your profile",
      "Create support tiers",
      "Schedule a drop",
      "Send a broadcast"
    ]
  },
  {
    title: "Social flow",
    items: [
      "Follow and unfollow a creator",
      "Like a moment",
      "Save a moment",
      "Comment from the feed dropdown",
      "Delete your own comment",
      "View saved moments",
      "Check Following feed"
    ]
  },
  {
    title: "Perks flow",
    items: [
      "Earn points from real actions",
      "Confirm low-quality comments do not earn points",
      "Check badges on comments",
      "Check user perks in Settings",
      "Check Perks Locker",
      "Check creator perk settings"
    ]
  },
  {
    title: "Discovery",
    items: [
      "Search for creators",
      "Search for moments",
      "View Discover page",
      "Check Drop Mode cards",
      "Check Almost Gone section",
      "Check Rising Creators section"
    ]
  },
  {
    title: "Safety",
    items: [
      "Report a moment",
      "Report a profile",
      "Block a user",
      "Confirm blocked user content is hidden",
      "Check Admin Reports page"
    ]
  },
  {
    title: "Visual polish",
    items: [
      "Test mobile layout",
      "Test dark mode",
      "Check image sizing consistency",
      "Check loading states",
      "Check empty states",
      "Check spacing and buttons",
      "Check no console errors"
    ]
  }
];

export default function BetaChecklist() {
  return (
    <div className="page">
      <div className="studio-shell">
        <div className="studio-header">
          <p className="landing-eyebrow">Private Beta</p>

          <h1>Launch readiness checklist.</h1>

          <p className="subtitle">
            Run through this checklist before inviting testers, creators, or early users.
          </p>
        </div>

        <div className="info-card-grid">
          {checklistSections.map((section) => (
            <div key={section.title} className="info-card">
              <h3>{section.title}</h3>

              <div className="beta-checklist-list">
                {section.items.map((item) => (
                  <label key={item} className="beta-checklist-item">
                    <input type="checkbox" />
                    <span>{item}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}